import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Check, Loader2, ShieldCheck, Sparkles } from 'lucide-react';
import ZoeaLogo from '@/components/ZoeaLogo';
import { useAuth } from '@/context/AuthContext';
import './DemoPage.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DemoPage = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState('intro');
  const [error, setError] = useState('');
  const requestStarted = useRef(false);

  const startDemo = async () => {
    if (requestStarted.current) return;
    requestStarted.current = true;
    setStatus('loading');
    setError('');
    try {
      const response = await axios.post(`${API}/auth/demo-session`, null, { timeout: 15000 });
      if (!response.data?.access_token || !response.data?.user) {
        throw new Error('Ongeldig antwoord van de demoserver');
      }
      await loginWithToken(response.data.access_token, response.data.user);
      window.location.replace('/dashboard?demo=welkom');
    } catch (err) {
      requestStarted.current = false;
      setStatus('intro');
      setError(
        err.code === 'ECONNABORTED'
          ? 'Het klaarzetten duurt te lang. Controleer of de backend draait en probeer opnieuw.'
          : err.response?.data?.detail || 'De demo kon niet worden gestart. Probeer het opnieuw.'
      );
    }
  };

  useEffect(() => {
    document.title = 'Bekijk de echte Zoea-demo';
    return () => { document.title = 'Zoea'; };
  }, []);

  return <main className="demo-entry">
    <nav><Link to="/"><ZoeaLogo className="h-10" /></Link><Link to="/" className="demo-entry__back"><ArrowLeft /> Terug naar zoea.nl</Link></nav>
    <section>
      <div className="demo-entry__copy">
        <span className="demo-entry__badge"><Sparkles /> Dit is de echte Zoea-app</span>
        <h1>Zelf ervaren werkt<br /><em>beter dan uitleggen.</em></h1>
        <p>We openen een tijdelijke demo-organisatie in de werkelijke Zoea-omgeving. Alles wat je ziet gebruikt dezelfde pagina’s, bediening en modules als het product.</p>
        <ul>
          <li><Check /> Fictieve, veilige voorbeeldgegevens</li>
          <li><Check /> 45 minuten vrij rondkijken en proberen</li>
          <li><Check /> Geen registratie of creditcard nodig</li>
        </ul>
        {error && <div className="demo-entry__error">{error}</div>}
        <button onClick={startDemo} disabled={status === 'loading'}>{status === 'loading' ? <><Loader2 className="is-spinning" /> Demo wordt klaargezet…</> : <>Open de echte demo <ArrowRight /></>}</button>
        <small>Externe koppelingen, uploads en uitnodigingen zijn uitgeschakeld.</small>
      </div>
      <div className="demo-entry__visual" aria-hidden="true">
        <div className="demo-entry__window"><header><i /><i /><i /><span>app.zoea.nl/dashboard</span></header><div className="demo-entry__app"><aside><ZoeaLogo className="h-7" />{[1,2,3,4,5,6].map((item) => <i key={item} />)}</aside><div><span>Demo-organisatie</span><h2>Dashboard</h2><div className="demo-entry__stats">{[1,2,3,4].map((item) => <i key={item} />)}</div><div className="demo-entry__panels"><i /><i /></div></div></div></div>
        <div className="demo-entry__safe"><ShieldCheck /><span><strong>Veilige demosessie</strong><small>Automatisch opgeruimd</small></span></div>
      </div>
    </section>
    <footer>Project Zoea · praktisch beheer voor kerken</footer>
  </main>;
};

export default DemoPage;
